import { render } from "./SectionGE.vue?vue&type=template&id=c0d341ac&scoped=true"
import script from "./SectionGE.vue?vue&type=script&lang=js"
export * from "./SectionGE.vue?vue&type=script&lang=js"

import "./SectionGE.vue?vue&type=style&index=0&id=c0d341ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d341ac"]])

export default __exports__